import React, { useRef, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import "./product.css";
import publicUrls from "../../routes/publicUrls";
import { getSingaleData } from "../../Model/SinglePage";
import { getUser, storeAuctionLot } from "../../Model/LocalStorage";
import {
  getFilter,
  getPlaceAmount,
  postBid,
  actionByID,
  addfavorite,
  removefavorite,
} from "../../Model/Auction";
import { getToken, getProfile, JoinAuction, GetApprovedAuction } from "../../Model/User";
import { decodeId } from "../../hash";
import { GetURL, hostname } from "../../config";

// Page sections
import LotDetails from "./components/LotDetails";
import LotNavigation from "./components/LotNavigation";
import LotSummary from "./components/LotSummary";
import LotCatalogueFields from "./components/LotCatalogueFields";
import BidPanel from "./components/BidPanel";
import BidHistory from "./components/BidHistory";
import RelatedLots from "./components/RelatedLots";
// Dialogs / overlays
import LotDetailsModal from "./components/LotDetailsModal";
import BidDialog from "./components/BidDialog";
import ZoomDialog from "./components/ZoomDialog";
import RegisterDialog from "./components/RegisterDialog";
import BidResultBackdrop from "./components/BidResultBackdrop";
import AlertSnackbar from "./components/AlertSnackbar";
import InvalidBidDialog from "./components/InvalidBidDialog";
import ArtworkSEO from "../../components/SEO/ArtworkSEO";
const auctionType = localStorage.getItem("auctionType");

const getAuctionCacheKey = (id, page = 1, search = "") => {
  return `lots_page_${page}_id_${id}_search_${search}`;
};




function View() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const matches = useMediaQuery("(min-width:992px)");
  const phoneWidth = useMediaQuery("(max-width:1200px)");
  const isDesktop = useMediaQuery("(min-width:1024px)");
  const navigate = useNavigate();
  const routerLocation = useLocation(); // ✅ renamed to avoid ESLint conflict
  const token = getToken();
  const [loading, setLoading] = React.useState(false);
  const [state, setState] = React.useState({
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal } = state;
  const { id, lotNo, slug, titles } = useParams();

  const lotID = decodeId(id);

  const [previous, setPrevious] = useState(0);
  const [next, setNext] = useState(2);
  const [LotStatus, setLot_status] = React.useState("");
  const [idSet, setId] = React.useState("");
  const [group, setGroup] = React.useState("");

  const [title, setTitle] = React.useState("");
  const [artist, setArtist] = React.useState("");
  const [size, setSize] = React.useState("");
  const [medium, setMedium] = React.useState("");
  const [lotHtml, setLotHtml] = React.useState("");
  const [startingPrice, setStartingPrice] = React.useState("");
  const [signedDated, setSignDate] = React.useState("");
  const [coa, setCoa] = React.useState("");
  const [hp, setHp] = React.useState(0);
  const [provenance, setProvinance] = React.useState("");
  const [literature, setLiterature] = React.useState("");
  const [write_up, setWriteUp] = React.useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImage1, setSelectedImage1] = useState("");
  const items = JSON.parse(localStorage.getItem("@storeAuctionLot"));
  const [imageData, setImageData] = React.useState([]);
  const [lotNumber, setLotNumber] = useState(items === null ? 0 : lotNo);
  const [acceptBid, setAcceptBid] = useState(0);
  const [amountBid, setPlaceAmount1] = useState(null);
  const [nextBidAmount, setNextBidAmount] = useState(null);
  const [property, setProperty] = useState("");
  const [exhibited, setExhibited] = useState("");
  const [bidHistory, setBidHistory] = React.useState([]);
  const [tokenExpire, setTokenExpired] = useState("");
  const [message, setMessage] = useState("");
  const [openNotif1, setOpenNotif1] = React.useState(false);
  const [auctionId, setAuctionID] = useState("");
  const [bidderCount, setBidder] = useState(0);
  const [buyerPremium, setbuyerPremium] = useState(null);
  const [isWidraw, setIsWidraw] = useState(0);
  const [isDone, setIsdone] = useState(0);

  const [current, setCurrentBid] = useState(null);
  const [incrementData, setIncrementData] = useState([]);
  const [userBidder, setUserBidder] = useState("");
  const [favorite, setFavorite] = useState(null);

  const [accountID, setAccountId] = useState("");
  const [messageSuccess, setMessageSuccess] = React.useState(false);
  const [messageStatus, setMessageStatus] = React.useState(false);
  const [errorResult, setErrorResults] = React.useState("");

  const [zoom, setZoom] = React.useState(false);
  const [dateStart, setDateStart] = React.useState("");
  const [dateEnd, setDateEnd] = React.useState("");
  const [timeStart, setTimeStart] = React.useState("");
  const [timeEnd, setTimeEnd] = React.useState("");
  const [isLive, setIslive] = React.useState("");
  const [LOTIDNUMBER, setLOTID] = React.useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success"); // 'error', 'warning', 'info'
  const [status, setStatus] = useState("ended_auction"); // waiting | live | ended
  const [socket, setSocket] = useState(null);

  const [showHp, setShowHp] = useState(null);
  const FetchBanner = () => {
    setLoading(true);
    async function getBanner() {
      const results = await actionByID(lotID);
      setShowHp(results[0].showHp);
    }
    getBanner().catch(console.error);
  };

  useEffect(() => {
    FetchBanner();
  }, [id]);
  // Ilagay ito sa loob ng Lot.jsx, kasama ng iba pang useEffect blocks.

  useEffect(() => {
    const token = getToken();
    const auctionIdDecoded = decodeId(id);
    const currentLotNumber = lotNumber;

    const connectSocket = async () => {
      const user = await getUser();

      // 🚫 WAG mag-connect kung walang logged-in user
      if (!user || !user.id) {
        console.log("Guest user detected — socket connection skipped");
        return () => {};
      }

      // 1. Gumawa ng bagong socket connection
      const newSocket = hostname(token);
      setSocket(newSocket);

      newSocket.on("connect", () => {
        console.log("Socket connected");

        // ✅ LOGGED-IN USERS LANG
        newSocket.emit("ConnectedUser", {
          userId: user.id,
          email: user.email,
          group: user.group, // ADMIN / BIDDER / etc
        });
      });

      // 2. Bid Update Logic
      newSocket.on("receive_absentee_bid", (data) => {
        if (!data || data.amount === undefined || data.amount === null) return;

        const newAmount = Number(data.amount);
        if (isNaN(newAmount)) return;

        if (
          data.auction_id === auctionIdDecoded &&
          data.lot_number === currentLotNumber &&
          data.setId === idSet
        ) {
          setCurrentBid(newAmount);
          console.log(`✅ Current bid updated to: ${newAmount}`);
        }
      });

      // 3. Cleanup
      return () => {
        newSocket.disconnect();
        setSocket(null);
      };
    };

    let disconnect;
    connectSocket().then((cleanup) => {
      disconnect = cleanup;
    });

    return () => {
      if (disconnect) disconnect();
    };
  }, [id, idSet, lotNumber]);

  // useEffect(() => {
  //   // Kukunin ang necessary values mula sa scope ng Lot.jsx

  //   // Kukunin ang current lot number para sa matching


  //       localStorage.setItem("guest_id", guestId);
  //     }
  //       Math.random() * 100000
  //     )}@user.com`;

  //     // 1. Gumawa ng bagong socket connection
  //     // 💡 UPDATE: I-set ang socket state para magamit sa handlepostBid
  //     setSocket(newSocket);

  //     newSocket.on("connect", () => {
  //       console.log("Socket connected");
  //       newSocket.emit("ConnectedUser", {
  //         userId: user?.id || guestId,
  //         email: user?.email || guestEmail,
  //         group: user?.group || "BIDDER",
  //       });
  //     });

  //     // 2. Bid Update Logic
  //     newSocket.on("receive_absentee_bid", (data) => {
  //       console.log("📢 Received live bid:", data);
  //       // Basic validation
  //         !updatedBidData ||
  //         updatedBidData.amount === undefined ||
  //         updatedBidData.amount === null
  //       ) {
  //       }
  //         console.error(
  //           "Invalid amount received from socket:",
  //           updatedBidData.amount
  //         );
  //       }

  //       // --- MATCHING LOGIC: Tiyakin na para sa current Lot ang bid na ito ---
  //         updatedBidData.auction_id === auctionIdDecoded &&
  //         updatedBidData.lot_number === currentLotNumber &&
  //         updatedBidData.setId === idSet // Dagdag na check para mas sigurado
  //       ) {
  //         // 💡 ACTION: I-update lang ang current bid amount
  //         setCurrentBid(newAmount);
  //         // FetchData(lotID, lotNo);
  //         console.log(`✅ Current bid updated to: ${newAmount}`);
  //       } else {
  //         console.log(
  //           "ℹ️ Bid received is for a different lot, ignoring update."
  //         );
  //       }
  //     });

  //     // 3. Clean-up Function
  //       newSocket.disconnect();
  //       // 💡 Cleanup: I-reset ang socket state
  //       setSocket(null);
  //     };
  //   };

  // }, [id, idSet, lotNumber]); // Dependencies: id, idSet, at lotNumber para mag-reconnect kung magbago ang Lot

  // skipEmit: load the lot without broadcasting absentee_bid (used when opening a related lot)
  const FetchData = async (lotID, lotNumber, data, skipEmit = false) => {
    setLoading(true);
    async function getData() {
      const results = await getSingaleData(lotID, lotNumber);
      if (results.msg === "no record found") {
        setLoading(false);
        setOpenNotif1(true);
        navigate("*");
        setMessage("No Record Found!");
      }
      const values = await getFilter(results.msg.data.auction_id);
      setDateStart(values[0].date_start);
      setDateEnd(values[0].date_end);
      setTimeStart(values[0].time_start);
      setTimeEnd(values[0].time_end);

      setIslive(values[0].isLive);
      setIsdone(results.msg.data.isDone);
      setIsWidraw(results.msg.data.isWithdrawn);
      setAcceptBid(values[0].accept_bid);
      setBidHistory(results.bid_history);
      setAuctionID(results.msg.data.auction_id);
      setId(results.msg.data.set_id);
      setPrevious(results.prev);
      setNext(results.next);
      // alert(typeof(results.msg.data.fav))
      setUserBidder(results.msg.data.userBid);
      setLOTID(results.msg.data.id);
      setFavorite(results.msg.data.fav);
      setTitle(results.msg.data.title);
      setArtist(results.msg.data.artist);
      setProperty(results.msg.data.property);
      setSize(results.msg.data.size);
      setMedium(results.msg.data.medium);
      setCoa(results.msg.data.coa || "");

      // Palitan ang mga linyang ito sa loob ng nextButton function:

      // alert(results.msg.data.signed_dated)
      setSignDate(results.msg.data.signed_dated);
      setStartingPrice(results.msg.data.starting_price);
      setLotHtml(results.msg.data.lot_details_html || "");
      setExhibited(results.msg.data.exhibited || "");
      setHp(
        results.msg.data.hammer_price === null ||
          results.msg.data.hammer_price === 0 ||
          results.msg.data.hammer_price === ""
          ? 0
          : results.msg.data.hammer_price
      );
      setLotNumber(results.msg.data.lot_number);
      setProvinance(results.msg.data.provenance || "");
      setLiterature(results.msg.data.literature || "");
      setWriteUp(results.msg.data.write_up || "");
      setbuyerPremium(results.msg.data.bp);
      setBidder(results.count_bid);
      setCurrentBid(
        results.msg.data.hp === null ||
          results.msg.data.hp === 0 ||
          results.msg.data.hp === ""
          ? 0
          : results.msg.data.hp
      );
      setLot_status(results.msg.data.lot_status);
      //   //console.log(results.msg.image)
      setImageData(results.msg.image);
      // //console.log(results.increment);
      setIncrementData(results.increment);
      setSelectedImage(
        results.msg.image.length
          ? results.msg.image[0].img_url
          : "https://placehold.co/600x400/EEE/31343C?font=lora&text=No%20Image%20Available"
      );

      setSelectedImage1(
        results.msg.image.length
          ? results.msg.image[0].img_url
          : "https://placehold.co/600x400/EEE/31343C?font=lora&text=No%20Image%20Available"
      );

      setTokenExpired(results.tokenExpired);

      if (socket && !skipEmit) {
        const florrData = {
          amount: results.msg.data.hp,
          auction_id: auctionId,
          lot_number: lotNumber,
          setId: idSet,
          // Idagdag ang user info kung kailangan ng server
        };

        // Siguraduhin na "send_bid_amount" ang tamang event name
        socket.emit("absentee_bid", florrData);
        console.log("⚡ Bid successfully emitted to socket:", florrData);
      }

      setLoading(false);
      if (results.tokenExpired === 1) {
        localStorage.removeItem("@storage_Key");
        localStorage.removeItem("token");
      }
      // //console.log( results.bid_history.map((val)=> group === "ADMIN" ? val.email:val.myBidAmount))

      const response = await getPlaceAmount(
        results.msg.data.auction_id,
        results.msg.data.set_id,
        results.msg.data.lot_number
      );
      //console.log("place bid: ", response.amount);
      setNextBidAmount(response.amount);
      setPlaceAmount1(response.amount);
      // lot/place_amount?auction_id=1&set_id=1&lot_number=1
    }
    getData().catch(console.error);
    // window.location.reload()
  };

  const [followed, setFollowed] = useState(false);
  const [advance, setAdvanced] = useState(true);
  const [forApproval, setForApproval] = useState(false);
  const [userInfo, setUserInfo] = useState([]);
  const [note, setNote] = useState("");
  const [showAdvance, setShowAdance] = useState(false);

  const handleCLickShoAdvance = () => {
    setShowAdance(true);
  };

  const handleJoinLiveAuction = (auctionId) => {
    const fetchData = async () => {
      setLoading(true);

      const date = new Date(dateStart);
      const options = {
        year: "numeric",
        month: "long",
        day: "2-digit",
        timeZone: "UTC", // Siguraduhin na ang dateStart ay tugma sa UTC kung gagamitin ito
      };

      const formatted = date.toLocaleDateString("en-US", options);

      //   year: "numeric",
      //   month: "long",
      //   day: "2-digit",
      //   hour: "numeric",
      //   minute: "2-digit",
      //   hour12: true,
      //   timeZone: "UTC",
      // };

      // I-convert ang string sa Date object para madaling ma-format
      const [hours, minutes] = timeStart.split(":");
      const timeDate = new Date();
      timeDate.setHours(parseInt(hours), parseInt(minutes));

      const timeOptions = {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      };

      const formattedTime = timeDate.toLocaleString("en-US", timeOptions);

      try {
        // 👉 Check approval status first
        const approvedRequest = await GetApprovedAuction(auctionId);
        const status = approvedRequest?.status;

        if (status === "approved") {
          // ✅ Already approved  Your participation has been approved. Kindly wait for the ${slug} schedule on ${formatted}
          setNote(
            `Your participation has been approved. You may now proceed to the live auction to join and place your bids on ${formatted} at ${formattedTime}.`
          );
          setForApproval(true);
          return;
        }

        if (status === "declined") {
          // ✅ Already approved  Your participation has been approved. Kindly wait for the ${slug} schedule on ${formatted}
          setNote(
            `You have declined to participate in this auction. For futher assistance, please contact Leon Gallery Staff or call (02)8856-2781`
          );
          setForApproval(true);
          return;
        }

        if (status === 0) {
          // ❌ Not approved yet — proceed to JoinAuction IF user is logged in
          if (!token) {
            setOpen(false);
            navigate("/login");
            return;
          }

          const data = await getProfile();

          //   throw new Error("Failed to get user profile.");
          // }

          const user = data.data[0];
          console.log(user);
          setUserInfo(user);


          const resultJoinAction = await JoinAuction(auctionId);

          if (!resultJoinAction.success) {
            if (resultJoinAction.msg === "You already joined this auction.") {
              setNote(
                `Your participation has been approved. You may now proceed to the live auction to join and place your bids on ${formatted} at ${formattedTime}.`
              );
            } else {
              setNote(resultJoinAction.msg);
            }
          } else {
            setNote(resultJoinAction.msg);
          }

          setForApproval(true);
          return;
        }

        // 🚫 No valid status
        setNote(
          "Your request is not approved yet. Please wait for admin approval."
        );
        setForApproval(true);
      } catch (err) {
        console.error("Error during auction joining:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  };

  const [openNotif2, setOpenNotif2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleCloseDialog = () => {
    setOpenNotif2(false);
    setErrorMessage("");
  };

  const { origin, pathname } = window.location;

  const parts = pathname.split("/").filter(Boolean);

  // kung number ang last segment, tanggalin
  if (!isNaN(parts[parts.length - 1])) {
    parts.pop();
  }

  const baseUrl = `${origin}/${parts.join("/")}/`;

  const handlepostBid = (e) => {
    e.preventDefault();
    setOpen(false);
    setLoading(true);
    setAdvanced(true);

    const bidValue = Number(amountBid);
    const bidAmount =
      bidValue === null || bidValue === 1000 ? startingPrice : bidValue;

    // 1. SILENT JOIN FUNCTION (Modified to be quiet)
    const triggerSilentJoin = async (user) => {
      try {
        // Check approval status muna para hindi spam sa API
        const approvedRequest = await GetApprovedAuction(auctionId);

        // Kung status is 0 (Pending) or null (Never joined), tsaka lang tayo mag-JoinAuction
        if (
          approvedRequest?.status === 0 ||
          !approvedRequest?.hasOwnProperty("status")
        ) {
          const res = await JoinAuction(auctionId);

          // Dedma lang kung "Already joined" ang response, wag na i-notif ang user
          if (res.success) {
            console.log("Auto-joined successfully");
          }
        }
      } catch (err) {
        console.error("Silent join check failed:", err);
      }
    };

    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getProfile();
        const user = data.data[0];
        setUserInfo(user);

        if (data.sucess) {
          // 🔥 CALL JOIN (No await, no UI blocking)
          // Ititigil na nito ang sarili niya kapag "Approved" o "Joined" na
          triggerSilentJoin(user);

          // 🚀 PROCEED TO BID IMMEDIATELY
          const bidData = {
            auction_id: auctionId,
            setId: idSet,
            lot_number: lotNumber,
            amount: bidAmount,
            url: `${baseUrl}${lotNumber}`,
          };

          const results = await postBid(bidData);
          setErrorResults(results.success);
          setShowAdance(false);

          if (!results.success) {
            // Dito lang natin papansinin yung "Not approved" kung galing mismo sa postBid API
            if (results.msg === "Not approved") {
              setMessageSuccess(
                "Your account is pending approval for this auction."
              );
            } else {
              const formattedMessage = results.msg
                .split(".")
                .map((sentence, index) =>
                  sentence.trim() ? (
                    <span key={index}>
                      {sentence.trim()}.<br />
                    </span>
                  ) : null
                );
              setMessageSuccess(formattedMessage);
            }
          } else {
            setMessageSuccess(results.msg);
            FetchData(lotID, lotNo);
          }

          setMessageStatus(true);
          setTimeout(() => setMessageStatus(false), 3000);
        }
      } catch (error) {
        console.error("Bid error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  };

  const previousButton = () => {
    // setPlaceAmount1(null);
    setInputValue("");
    const dataArray = {
      lot_id: lotID,
      lotNo: parseInt(lotNumber) - 1,
      // setDetails: idSet,
      // imageSingle: imageData[0].img_url,
      // title:title,
      // slug:slug
    };
    storeAuctionLot(dataArray);
    setIsLotListOpen(false);
    // FetchData(id, parseInt(lotNumber) - 1);
    async function getData() {
      const results = await getSingaleData(lotID, parseInt(lotNumber) - 1);
      if (results.msg === "no record found") {
        setLoading(false);
        setOpenNotif1(true);
        navigate("*");
        setMessage("No Record Found!");
      }
      const values = await getFilter(results.msg.data.auction_id);
      setAcceptBid(values[0].accept_bid);
      setBidHistory(results.bid_history);
      setAuctionID(results.msg.data.auction_id);
      setId(results.msg.data.set_id);
      setPrevious(results.prev);
      setNext(results.next);
      setUserBidder(results.msg.data.userBid);
      setFavorite(results.msg.data.fav);
      setLOTID(results.msg.data.id);
      setTitle(results.msg.data.title);
      setArtist(results.msg.data.artist);
      setProperty(results.msg.data.property);
      setSize(results.msg.data.size);
      setMedium(results.msg.data.medium);
      setCoa(results.msg.data.coa || "");
      setSignDate(results.msg.data.signed_dated);
      setStartingPrice(results.msg.data.starting_price);
      setLotHtml(results.msg.data.lot_details_html || "");
      setExhibited(results.msg.data.exhibited || "");
      setIsWidraw(results.msg.data.isWithdrawn);
      setIsdone(results.msg.data.isDone);
      setHp(
        results.msg.data.hammer_price === null ||
          results.msg.data.hammer_price === 0 ||
          results.msg.data.hammer_price === ""
          ? results.msg.data.starting_price
          : results.msg.data.hammer_price
      );
      setLotNumber(results.msg.data.lot_number);
      setProvinance(results.msg.data.provenance || "");
      setLiterature(results.msg.data.literature || "");
      setWriteUp(results.msg.data.write_up || "");
      setbuyerPremium(results.msg.data.bp);
      setBidder(results.count_bid);
      setCurrentBid(
        results.msg.data.hp === null ||
          results.msg.data.hp === 0 ||
          results.msg.data.hp === ""
          ? 0
          : results.msg.data.hp
      );

      setLot_status(results.msg.data.lot_status);
      //   //console.log(results.msg.image)
      setImageData(results.msg.image);
      // //console.log(results.increment);
      setIncrementData(results.increment);
      setSelectedImage(
        results.msg.image.length
          ? results.msg.image[0].img_url
          : "https://placehold.co/600x400/EEE/31343C?font=lora&text=No%20Image%20Available"
      );

      setSelectedImage1(
        results.msg.image.length
          ? results.msg.image[0].img_url
          : "https://placehold.co/600x400/EEE/31343C?font=lora&text=No%20Image%20Available"
      );

      setTokenExpired(results.tokenExpired);
      setLoading(false);
      if (results.tokenExpired === 1) {
        localStorage.removeItem("@storage_Key");
        localStorage.removeItem("token");
      }
      // //console.log( results.bid_history.map((val)=> group === "ADMIN" ? val.email:val.myBidAmount))

      const response = await getPlaceAmount(
        results.msg.data.auction_id,
        results.msg.data.set_id,
        results.msg.data.lot_number
      );

      setNextBidAmount(response.amount);
      setPlaceAmount1(response.amount);

      // lot/place_amount?auction_id=1&set_id=1&lot_number=1

      const cleanTitle =
        results.msg.data.title === null
          ? "untitle"
          : results.msg.data.title.replace(/[^a-zA-Z0-9-_]/g, "");
      navigate(publicUrls.lot(slug, id, parseInt(lotNumber) - 1, cleanTitle));

      // navigate(`/auctions/${slug}/${encodeURIComponent(results.msg.data.title).replace(/%20[^a-zA-Z0-9-_]/g, "-")}/${encodeId(id)}/${parseInt(lotNumber) - 1}`)
    }

    getData().catch(console.error);

    // navigate(
    //   `/auctions/${slug}/${
    //   }/${id}/${parseInt(lotNumber) - 1}`
    // );
  };

  const nextButton = async () => {
    setInputValue("");
    const dataArray = {
      lot_id: id,
      lotNo: parseInt(lotNumber) + 1,
    };
    setIsLotListOpen(false);
    storeAuctionLot(dataArray);
    // setPlaceAmount1(null);

    async function getData() {
      const results = await getSingaleData(lotID, parseInt(lotNumber) + 1);
      if (results.msg === "no record found") {
        setLoading(false);
        setOpenNotif1(true);
        navigate("*");
        setMessage("No Record Found!");
      }
      const values = await getFilter(results.msg.data.auction_id);
      setAcceptBid(values[0].accept_bid);
      setBidHistory(results.bid_history);
      setAuctionID(results.msg.data.auction_id);
      setId(results.msg.data.set_id);
      setPrevious(results.prev);
      setNext(results.next);
      setUserBidder(results.msg.data.userBid);
      setLOTID(results.msg.data.id);
      setFavorite(results.msg.data.fav);
      setTitle(results.msg.data.title);
      setArtist(results.msg.data.artist);
      setProperty(results.msg.data.property);
      setSize(results.msg.data.size);
      setMedium(results.msg.data.medium);
      setCoa(results.msg.data.coa || "");
      setSignDate(results.msg.data.signed_dated);
      setStartingPrice(results.msg.data.starting_price);
      setLotHtml(results.msg.data.lot_details_html || "");
      setExhibited(results.msg.data.exhibited || "") ;
      setIsWidraw(results.msg.data.isWithdrawn);
      setIsdone(results.msg.data.isDone);
      setHp(
        results.msg.data.hammer_price === null ||
          results.msg.data.hammer_price === 0 ||
          results.msg.data.hammer_price === ""
          ? results.msg.data.starting_price
          : results.msg.data.hammer_price
      );
      setLotNumber(results.msg.data.lot_number);
      setProvinance(results.msg.data.provenance || "");
      setLiterature(results.msg.data.literature || "");
      setWriteUp(results.msg.data.write_up || "");
      setbuyerPremium(results.msg.data.bp);
      setBidder(results.count_bid);
      setCurrentBid(
        results.msg.data.hp === null ||
          results.msg.data.hp === 0 ||
          results.msg.data.hp === ""
          ? 0
          : results.msg.data.hp
      );

      setLot_status(results.msg.data.lot_status);
      //   //console.log(results.msg.image)
      setImageData(results.msg.image);
      // //console.log(results.increment);
      setIncrementData(results.increment);
      setSelectedImage(
        results.msg.image.length
          ? results.msg.image[0].img_url
          : "https://placehold.co/600x400/EEE/31343C?font=lora&text=No%20Image%20Available"
      );

      setSelectedImage1(
        results.msg.image.length
          ? results.msg.image[0].img_url
          : "https://placehold.co/600x400/EEE/31343C?font=lora&text=No%20Image%20Available"
      );

      //console.log(" setTokenExpired", results.tokenExpired);
      setTokenExpired(results.tokenExpired);
      setLoading(false);
      if (results.tokenExpired === 1) {
        localStorage.removeItem("@storage_Key");
        localStorage.removeItem("token");
      }
      // //console.log( results.bid_history.map((val)=> group === "ADMIN" ? val.email:val.myBidAmount)) h

      const response = await getPlaceAmount(
        results.msg.data.auction_id,
        results.msg.data.set_id,
        results.msg.data.lot_number
      );

      //console.log("place bid: ", response.amount);
      setNextBidAmount(response.amount);
      setPlaceAmount1(response.amount);

      // lot/place_amount?auction_id=1&set_id=1&lot_number=1

      const cleanTitle =
        results.msg.data.title === null
          ? "untitle"
          : results.msg.data.title.replace(/[^a-zA-Z0-9-_]/g, "");

      navigate(publicUrls.lot(slug, id, parseInt(lotNumber) + 1, cleanTitle));

      // navigate(`/auctions/${slug}/${encodeURIComponent(results.msg.data.title).replace(/%20/g, "-")}/${decodeId(id)}/${parseInt(lotNumber) + 1}`)
    }

    getData().catch(console.error);
  };

  // Function para sa Cache

  const [cachedTotal, setCachedTotal] = useState(0);
  useEffect(() => {
    // Kunin ang key gamit ang parehong format
    const key = getAuctionCacheKey(id, 1, "");
    const saved = sessionStorage.getItem(key);

    if (saved) {
      const parsed = JSON.parse(saved);
      setCachedTotal(parsed.totalCount); // Makuha na yung Count dito
    }
  }, [id]);

  const [isLotListOpen, setIsLotListOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // <--- IDAGDAG ITO

  const handleGoToLot = async (targetNo) => {
    const targetLot = parseInt(targetNo);
    if (!targetLot || targetLot < 1) return;

    setLoading(true);
    setInputValue("");

    try {
      const results = await getSingaleData(lotID, targetLot);

      if (!results || results.msg === "no record found") {
        setLoading(false);
        setOpenNotif1(true);
        setMessage("Lot " + targetLot + " not found.");
        return;
      }

      const item = results.msg.data;
      const filterValues = await getFilter(item.auction_id);

      // --- STATE UPDATES ---
      setAcceptBid(filterValues[0].accept_bid);
      setAuctionID(item.auction_id);
      setId(item.set_id);
      setLotNumber(item.lot_number);

      // ✅ IMPORTANTE: I-update ito para hindi mawala ang buttons
      setPrevious(results.prev);
      setNext(results.next);

      setBidHistory(results.bid_history);
      setTitle(item.title);
      setArtist(item.artist);
      setProperty(item.property);
      setImageData(results.msg.image);

      // Iba pang states na kailangan base sa original code mo
      setUserBidder(item.userBid);
      setFavorite(item.fav);
      setLOTID(item.id);
      setSize(item.size);
      setMedium(item.medium);
      setCoa(item.coa);

      setWriteUp(item.write_up);
      setProvinance(item.provenance);
      setCoa(item.coa);
      setExhibited(item.exhibited);
      setLiterature(item.literature);
      
      // I-update din ang image arrays kung meron
      
      setSignDate(item.signed_dated);
      setStartingPrice(item.starting_price);
      setLotHtml(item.lot_details_html);
      setExhibited(item.exhibited);
      setIsWidraw(item.isWithdrawn);
      setIsdone(item.isDone);
      setLot_status(item.lot_status);
      setIncrementData(results.increment);
      setTokenExpired(results.tokenExpired);

      const imgUrl = results.msg.image.length
        ? results.msg.image[0].img_url
        : "https://placehold.co/600x400?text=No+Image";
      setSelectedImage(imgUrl);
      setSelectedImage1(imgUrl);

      // Fetch Place Amount para sa bidding block
      const response = await getPlaceAmount(
        item.auction_id,
        item.set_id,
        item.lot_number
      );
      setNextBidAmount(response.amount);
      setPlaceAmount1(response.amount);

      // --- NAVIGATION ---
    } catch (error) {
      console.error("Error in handleGoToLot:", error);
    } finally {
      setLoading(false);
    }
  };

  const [open, setOpen] = React.useState(false);
  const [bp, setBp] = React.useState("");

  const handleClickOpen = () => {
    const fetchData = async () => {
      setLoading(true);
      setOpen(true);

      const date = new Date(dateStart);
      const options = {
        year: "numeric",
        month: "long",
        day: "2-digit",
        timeZone: "UTC", // Siguraduhin na ang dateStart ay tugma sa UTC kung gagamitin ito
      };

      const formatted = date.toLocaleDateString("en-US", options);

      try {
        // 👉 Check approval status first
        const approvedRequest = await GetApprovedAuction(auctionId);
        const status = approvedRequest?.status;

        const [hours, minutes] = timeStart.split(":");
        const timeDate = new Date();
        timeDate.setHours(parseInt(hours), parseInt(minutes));

        const timeOptions = {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        };

        const formattedTime = timeDate.toLocaleString("en-US", timeOptions);

        if (status === "approved") {
          // ✅ Already approved
          setNote(
            `Your participation has been approved. You may now proceed to the live auction to join and place your bids on ${formatted} at ${formattedTime}.`
            // `Your participation has been approved. Kindly wait for the ${slug} schedule on ${formatted}`
          );
          setForApproval(true);
          return;
        }

        if (status === "declined") {
          // ✅ Already approved  Your participation has been approved. Kindly wait for the ${slug} schedule on ${formatted}
          setNote(
            `You have declined to participate in this auction. For futher assistance, please contact Leon Gallery Staff or call (02)8856-2781`
          );
          setForApproval(true);
          return;
        }

        if (status === 0) {
          // ❌ Not approved yet — proceed to JoinAuction IF user is logged in
          if (!token) {
            setOpen(false);
            navigate("/login");
            return;
          }
          const data = await getProfile();
          //   throw new Error("Failed to get user profile.");
          // }
          const user = data.data[0];
          console.log(user);
          setUserInfo(user);

          setForApproval(false);
          // navigate("/signup", { state: { from: location.pathname } });

          return;
        }
        // 🚫 No valid status
        setNote(
          "Your request is not approved yet. Please wait for admin approval."
        );
        setForApproval(true);
      } catch (err) {
        console.error("Error during auction joining:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  };

  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return;
    }

    setForApproval(false);
    setZoom(false);
    setOpen(false);
    setShowAdance(false);
  };

  useEffect(() => {
    FetchData(lotID, lotNo);

    async function getUserList() {
      const getuser = await getUser();
      setGroup(getuser.group);
      setAccountId(getuser.id);
    }
    // window.location.reload()
    getUserList().catch(console.error);
  }, [slug]);

  const handleChange1 = async (e) => {
    e.preventDefault();
    setPlaceAmount1(e.target.value);
  };

  const [detailsShow, setDetailShow] = useState(false);

  //   setDetailShow(!detailsShow);
  // };

  const [provinanceShow, setProvinanceShow] = useState(false);
  const ProvinanceFunction = () => {
    setProvinanceShow(!provinanceShow);
  };

  const [exhibitedShow, setExhibitedShow] = useState(false);
  const ExhibitedFunction = () => {
    setExhibitedShow(!exhibitedShow);
  };

  const [writeupShow, setWriteUpShow] = useState(false);
  const WriteupFunction = () => {
    setWriteUpShow(!writeupShow);
  };

  const [literatureShow, setLiteratureShow] = useState(false);
  const literatureFunction = () => {
    setLiteratureShow(!literatureShow);
  };

  const [scrollPosition, setScrollPosition] = useState(0);
  const [bottomScroll, setBottomScroll] = useState("");

  const handleScroll = (e) => {
    const position = window.pageYOffset;
    //  //console.log(  (document.documentElement.scrollHeight - document.documentElement.clientHeight ) / 2)
    //  //console.log( position)
    //  //console.log(window.pageYOffset)

    var testdd =
      (document.documentElement.scrollHeight -
        document.documentElement.clientHeight) /
      2;
    //console.log(testdd);
    setBottomScroll(testdd);
    //  setScrollPositionTrue( Math.ceil(document.documentElement.scrollHeight - document.documentElement.scrollTop) === document.documentElement.clientHeight )
    setScrollPosition(position);
  };

  useEffect(() => {
    // alert(lotID)
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [token]);

  const handleBackPage = (id) => {
    // //console.log(id)
    window.location.href = publicUrls.auction(slug, id);
  };


  const gotoLogin = () => {
    window.location.href = `/login`;
  };

  const [nextAmount, setNextAmount] = useState(null);

  useEffect(() => {
    try {
      const currentIndex = incrementData.indexOf(
        Math.max(...bidHistory.map((bid) => bid.amount))
      );

      const currentIndex1 = incrementData.indexOf(
        Math.max(...bidHistory.map((bid) => bid.myBidAmount))
      );

      setNextAmount(incrementData[currentIndex + 1]);
      // setPlaceAmount1(nextAmount === null || nextAmount === undefined ? 0 : parseInt(nextAmount).toLocaleString());

      if (group === "ADMIN") {
        setNextAmount(incrementData[currentIndex + 1]);
        // setCurrentBid(incrementData[currentIndex])
      } else {
        setNextAmount(incrementData[currentIndex1 + 1]);
        // setCurrentBid(incrementData[currentIndex1])
      }
    } catch (error) {}
  }, [incrementData]);

  const [inputValue, setInputValue] = React.useState(""); // Text input

  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const lastPosition = useRef({ x: 0, y: 0 });

  const handleZoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3));
  const handleZoomOut = () => setScale((prev) => Math.max(prev - 0.2, 1));
  const resetZoom = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  };

  const handleMouseDown = (e) => {
    if (scale <= 1) return;
    setIsDragging(true);
    lastPosition.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
  };

  const handleMouseMove = (e) => {
    if (!isDragging || scale <= 1) return;
    setPosition({
      x: e.clientX - lastPosition.current.x,
      y: e.clientY - lastPosition.current.y,
    });
  };

  const handleMouseUp = () => setIsDragging(false);

  const handleTouchStart = (e) => {
    if (scale <= 1) return;
    const touch = e.touches[0];
    lastPosition.current = {
      x: touch.clientX - position.x,
      y: touch.clientY - position.y,
    };
  };

  const handleTouchMove = (e) => {
    if (scale <= 1) return;
    const touch = e.touches[0];
    setPosition({
      x: touch.clientX - lastPosition.current.x,
      y: touch.clientY - lastPosition.current.y,
    });
  };

  const [timeLeft, setTimeLeft] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  useEffect(() => {
    let interval;

    const startCountdown = async () => {
      try {
        const response = await fetch(`${GetURL}/api/server-time`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data = await response.json();
        let serverTime = new Date(data.serverTime);

        const startDate = new Date(`${dateStart.split("T")[0]}T${timeStart}`);
        const endDate = new Date(`${dateEnd.split("T")[0]}T${timeEnd}`);

        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
          // console.error("❌ Invalid start or end date");
          setStatus("error");
          return;
        }

        if (serverTime < startDate) {
          setStatus("waiting");
        } else if (serverTime >= startDate && serverTime < endDate) {
          setStatus("live");
        } else if (serverTime >= endDate) {
          setStatus("ended_auction");
          setTimeLeft({
            days: "00",
            hours: "00",
            minutes: "00",
            seconds: "00",
          });
          return;
        }

        interval = setInterval(() => {
          const diff = endDate - serverTime;

          if (diff <= 0) {
            clearInterval(interval);
            setStatus("ended_auction");
            setTimeLeft({
              days: "00",
              hours: "00",
              minutes: "00",
              seconds: "00",
            });
            return;
          }

          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((diff / (1000 * 60)) % 60);
          const seconds = Math.floor((diff / 1000) % 60);

          setTimeLeft({
            days: String(days).padStart(2, "0"),
            hours: String(hours).padStart(2, "0"),
            minutes: String(minutes).padStart(2, "0"),
            seconds: String(seconds).padStart(2, "0"),
          });

          // Increment serverTime by 1 second
          serverTime = new Date(serverTime.getTime() + 1000);
        }, 1000);
      } catch (error) {
        console.error("❌ Error in countdown:", error);
        setStatus("error");
      }
    };

    startCountdown();

    return () => clearInterval(interval);
  }, [dateStart, timeStart, dateEnd, timeEnd, GetURL]);

  const getLabel = () => {
    switch (status) {
      case "waiting":
        return "LIVE BIDDING STARTS IN:";
      case "live":
        return "BIDDING ENDS IN:";
      case "ended":
        return "End Of Auction";
      default:
        return "";
    }
  };

  const [open1, setOpen1] = useState(false);

  const RegisterToBid = () => {
    setOpen1(true);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };

  const handleLogin = () => {
    // your login logic here
    window.location.href = `/login`;
  };

  const handleRegister = () => {
    // your register logic here

    window.location.href = `/signup`;
  };

  const handleLater = () => {
    //console.log("Later clicked");
    setOpen1(false);
  };
  const formatDateDayMonthYear = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);

    const day = date.getDate(); // Get day (single digit if < 10)
    const month = date.toLocaleDateString("en-US", {
      month: "short", // Abbreviated month (e.g., "Oct")
    });
    const year = date.getFullYear(); // Get full year (e.g., 2025)

    return `${day} ${month}`;
  };

  //   window.location.href = `/auctions/room`;
  // };

  function getHighestMyBidAmount(bidHistory) {
    if (!Array.isArray(bidHistory) || bidHistory.length === 0) return null;

    // Filter out invalid or null myBidAmount and parse to number
    const validAmounts = bidHistory
      .map((bid) => Number(bid.myBidAmount))
      .filter((amount) => !isNaN(amount));

    if (validAmounts.length === 0) return null;

    // Get the highest amount
    return Math.max(...validAmounts);
  }

  const highestBid = getHighestMyBidAmount(bidHistory);

  const handlickFavorite = async (lotId) => {
    if (!token) {
      window.location.href = "/login";
      return;
    }

    try {
      const currentFavStatus = favorite;

      if (currentFavStatus === 1) {
        // Currently followed, so unfollow
        const res = await removefavorite({ lot_id: lotId });
        if (res.status === true) {
          setFavorite(0); // Now unfollowed ✅
        }
      } else {
        // Currently not followed, so follow
        const res = await addfavorite({ lot_id: lotId });
        if (res.status === true) {
          setFavorite(1); // Now followed ✅
        }
      }
    } catch (err) {
      console.error("Favorite toggle failed:", err);
    }
  };

  const formatDateTime = (dateEnd, timeEnd) => {
    if (!dateEnd || !timeEnd) return "";

    const date = new Date(dateEnd);

    const [hours, minutes, seconds] = timeEnd.split(":").map(Number);

    const combinedDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      minutes,
      seconds || 0
    );

    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(combinedDate);
  };

  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState({ label: "", val: "" });
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const handleOpenModal = (label, val) => {
    setModalContent({ label, val });
    setOpenModal(true);
  };

  // Titingnan nito kung lahat ay empty o null.
  // Kung lahat empty, false ang 'hasAnyDetails', kaya mawawala ang button.
  const hasAnyDetails = [coa, provenance, exhibited, literature, write_up].some(
    (val) => {
      if (!val) return false; // Kung null, undefined, o ""

      // Alisin ang HTML tags at i-trim ang spaces para makita kung may totoong text
      const cleanText = String(val)
        .replace(/<[^>]*>/g, "")
        .trim();

      // I-hide kung ang text ay empty o ang literal na salitang "null"
      return cleanText !== "" && cleanText.toLowerCase() !== "null";
    }
  );

  const formatText = (text = "") => {
    if (!text) return "";

    // kung may <br> na, wag na galawin
    if (/<br\s*\/?>/i.test(text)) {
      return text;
    }

    // palitan lang ang newline
    return text.replace(/\n/g, "<br />");
  };


  const artistHtml = lotHtml
    ? new DOMParser()
        .parseFromString(lotHtml, "text/html")
        .querySelector("strong")?.textContent || ""
    : "";

  const cleanedHtml = lotHtml
    ? lotHtml.replace(/<strong>.*?<\/strong>/, "")
    : "";

  const [isExpanded, setIsExpanded] = useState(false);

  // Related lot clicked: load it with the page's existing loader (the data effect only
  // re-runs when `slug` changes), then update the URL the same way Prev / Next do.
  const handleSelectRelatedLot = (targetLotNumber, cleanTitle) => {
    setInputValue("");
    setIsLotListOpen(false);
    storeAuctionLot({ lot_id: id, lotNo: parseInt(targetLotNumber) });
    FetchData(lotID, targetLotNumber, undefined, true);
    navigate(publicUrls.lot(slug, id, targetLotNumber, cleanTitle));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const seoDescription = [lotHtml, write_up, medium, size, property]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <ArtworkSEO
        title={title}
        artist={artist}
        description={seoDescription}
        image={selectedImage || selectedImage1}
        lotNumber={lotNumber}
        auctionName={group}
        auctionSlug={slug}
        auctionId={id}
        canonical={publicUrls.lot(slug, id, lotNumber, title || titles || "")}
      />
      <div style={{ padding: 11, paddingTop: 30 }}>
        <div
          className="container-fluid single-product-bell-mt"
          style={{
            marginTop: "20px",
            backgroundColor: "#fff",
            fontFamily: "Bell MT, Georgia, 'Times New Roman', serif",
          }}
        >
          
          <nav
            aria-label="breadcrumb"
            style={{ margin: "0 0 20px 0", background: "transparent" }}
          >
            <ol
              className="breadcrumb"
              style={{
                display: "flex",
                alignItems: "center",
                listStyle: "none",
                margin: 0,
                padding: 0,
                flexWrap: "nowrap",
                overflowX: "auto",
                scrollbarWidth: "none",
                whiteSpace: "nowrap",
              }}
            >
              <style>{`ol.breadcrumb::-webkit-scrollbar { display: none; }`}</style>
              <li
                style={{ display: "flex", alignItems: "center", flexShrink: 0 }}
              >
                <a
                  href="/home"
                  style={{
                    textDecoration: "none",
                    fontSize: "14px",
                    color: "#888",
                  }}
                >
                  HOME
                </a>
                <span style={{ margin: "0 8px", color: "#ccc" }}>/</span>
              </li>
              <li
                style={{ display: "flex", alignItems: "center", flexShrink: 0 }}
              >
                <a
                  href="/auctions"
                  style={{
                    textDecoration: "none",
                    fontSize: "14px",
                    color: "#888",
                  }}
                >
                  AUCTIONS
                </a>
                <span style={{ margin: "0 8px", color: "#ccc" }}>/</span>
              </li>
              {slug && (
                <li
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexShrink: 1,
                    minWidth: 0,
                  }}
                >
                  <a
                    href="javascript:void(0)"
                    onClick={() => handleBackPage(id)}
                    style={{
                      textDecoration: "none",
                      fontSize: "14px",
                      color: "#888",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "150px",
                      display: "block",
                      textTransform: "uppercase", // ✅ CAPITAL
                    }}
                  >
                    {slug}
                  </a>
                </li>
              )}
            </ol>
          </nav>

          <div
            className="row g-4"
            style={{
              position: "relative",
              alignItems: "flex-start",
              display: "flex",
            }}
          >
            {/* LEFT: images + catalogue details */}
            <div className="col-lg-8 order-1">
              <LotDetails
                isWidraw={isWidraw}
                title={title}
                imageData={imageData}
                selectedImage={selectedImage}
                selectedImage1={selectedImage1}
                setSelectedImage1={setSelectedImage1}
                setZoom={setZoom}
              />
              <LotCatalogueFields
                ExhibitedFunction={ExhibitedFunction}
                ProvinanceFunction={ProvinanceFunction}
                WriteupFunction={WriteupFunction}
                coa={coa}
                exhibited={exhibited}
                exhibitedShow={exhibitedShow}
                formatText={formatText}
                isDesktop={isDesktop}
                isWidraw={isWidraw}
                literature={literature}
                literatureFunction={literatureFunction}
                literatureShow={literatureShow}
                provenance={provenance}
                provinanceShow={provinanceShow}
                write_up={write_up}
                writeupShow={writeupShow}
              />
            </div>

            {/* RIGHT: navigation + bidding (sticky on desktop) */}
            <div
              className="col-lg-4 order-2"
              style={{
                position: phoneWidth === false ? "sticky" : "static",
                top: "150px",
                zIndex: 5,
                alignSelf: "flex-start",
                height: "fit-content",
              }}
            >
              <div style={{ backgroundColor: "#fff", paddingBottom: "10px" }}>
                <LotNavigation
                  cachedTotal={cachedTotal}
                  handleGoToLot={handleGoToLot}
                  isLotListOpen={isLotListOpen}
                  isWidraw={isWidraw}
                  lotNumber={lotNumber}
                  next={next}
                  nextButton={nextButton}
                  previous={previous}
                  previousButton={previousButton}
                  property={property}
                  searchTerm={searchTerm}
                  setIsLotListOpen={setIsLotListOpen}
                  setSearchTerm={setSearchTerm}
                />

                <LotSummary
                  artist={artist}
                  artistHtml={artistHtml}
                  cleanedHtml={cleanedHtml}
                  formatText={formatText}
                  hasAnyDetails={hasAnyDetails}
                  isDesktop={isDesktop}
                  isExpanded={isExpanded}
                  isWidraw={isWidraw}
                  lotHtml={lotHtml}
                  medium={medium}
                  setIsExpanded={setIsExpanded}
                  setOpenDetailsModal={setOpenDetailsModal}
                  signedDated={signedDated}
                  size={size}
                  title={title}
                />

                <BidPanel
                  LotStatus={LotStatus}
                  RegisterToBid={RegisterToBid}
                  auctionType={auctionType}
                  current={current}
                  handleClickOpen={handleClickOpen}
                  hp={hp}
                  isDone={isDone}
                  isWidraw={isWidraw}
                  showHp={showHp}
                  startingPrice={startingPrice}
                  status={status}
                  timeLeft={timeLeft}
                  token={token}
                />

                <BidHistory
                  LotStatus={LotStatus}
                  accountID={accountID}
                  bidHistory={bidHistory}
                  bidderCount={bidderCount}
                  current={current}
                  group={group}
                  isWidraw={isWidraw}
                  token={token}
                  userBidder={userBidder}
                />
              </div>
            </div>
          </div>

          <RelatedLots
            auctionId={auctionId}
            currentLotNumber={lotNumber}
            totalLots={cachedTotal}
            lotID={lotID}
            onSelectLot={handleSelectRelatedLot}
          />
        </div>

        <LotDetailsModal
          coa={coa}
          exhibited={exhibited}
          literature={literature}
          openDetailsModal={openDetailsModal}
          provenance={provenance}
          setOpenDetailsModal={setOpenDetailsModal}
          write_up={write_up}
        />

        <BidDialog
          LOTIDNUMBER={LOTIDNUMBER}
          amountBid={amountBid}
          artist={artist}
          auctionId={auctionId}
          auctionType={auctionType}
          current={current}
          dateStart={dateStart}
          favorite={favorite}
          forApproval={forApproval}
          formatDateTime={formatDateTime}
          handleCLickShoAdvance={handleCLickShoAdvance}
          handleClose={handleClose}
          handleJoinLiveAuction={handleJoinLiveAuction}
          handlepostBid={handlepostBid}
          handlickFavorite={handlickFavorite}
          highestBid={highestBid}
          incrementData={incrementData}
          inputValue={inputValue}
          lotID={lotID}
          matches={matches}
          next={next}
          note={note}
          open={open}
          selectedImage={selectedImage}
          setInputValue={setInputValue}
          setPlaceAmount1={setPlaceAmount1}
          setShowAdance={setShowAdance}
          showAdvance={showAdvance}
          startingPrice={startingPrice}
          timeStart={timeStart}
          title={title}
        />

        <ZoomDialog
          handleClose={handleClose}
          handleMouseDown={handleMouseDown}
          handleMouseMove={handleMouseMove}
          handleMouseUp={handleMouseUp}
          handleTouchMove={handleTouchMove}
          handleTouchStart={handleTouchStart}
          handleZoomIn={handleZoomIn}
          handleZoomOut={handleZoomOut}
          isDragging={isDragging}
          isMobile={isMobile}
          isWidraw={isWidraw}
          position={position}
          resetZoom={resetZoom}
          scale={scale}
          selectedImage1={selectedImage1}
          zoom={zoom}
        />

        <div
          className="modal"
          id="exampleModalCenter"
          tabindex={lotNumber}
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          // aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{ maxWidth: 600 }}
          >
            <div
              className="modal-content"
              style={{
                backgroundColor: "red",
                marginTop: phoneWidth === false ? -20 : 100,
              }}
            >
              <img src={selectedImage1} alt="" />
            </div>
          </div>
        </div>

        <BidResultBackdrop
          errorResult={errorResult}
          messageStatus={messageStatus}
          messageSuccess={messageSuccess}
        />

        <RegisterDialog
          handleClose1={handleClose1}
          handleLater={handleLater}
          handleLogin={handleLogin}
          handleRegister={handleRegister}
          isMobile={isMobile}
          open1={open1}
        />

        <AlertSnackbar
          alertMessage={alertMessage}
          alertOpen={alertOpen}
          alertSeverity={alertSeverity}
          setAlertOpen={setAlertOpen}
        />

        <InvalidBidDialog
          handleCloseDialog={handleCloseDialog}
          openNotif2={openNotif2}
        />

        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
}

export default View;
